import { Link } from "react-router-dom";

export default function Hero() {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative overflow-hidden min-h-screen bg-gradient-to-br from-slate-50 via-white to-indigo-50 pt-24"
    >
      <div className="absolute -left-24 top-24 h-72 w-72 rounded-full bg-blue-200/40 blur-3xl animate-blob" />
      <div className="absolute right-0 top-44 h-96 w-96 rounded-full bg-purple-200/30 blur-3xl animate-blob" />

      <div className="max-w-6xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-12 items-center relative">
        <div className="space-y-8">
          <span className="inline-flex items-center rounded-full bg-blue-100 text-blue-700 text-sm font-semibold px-5 py-2 shadow-sm shadow-blue-100 animate-fade-in">
            🚀 Leading IT Solutions Provider
          </span>

          <div className="space-y-6">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-900 leading-tight animate-fade-in animate-fade-in-delay-100">
              Crafting <span className="text-blue-600">Digital Excellence</span> for the Modern World
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed max-w-xl animate-fade-in animate-fade-in-delay-200">
              Our expertise spans design, development, and cloud innovation—delivering tailored solutions that elevate brands and accelerate success in a rapidly evolving digital landscape.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 animate-fade-in animate-fade-in-delay-300">
            {[
              { value: "200+", label: "Projects Done" },
              { value: "50+", label: "Happy Clients" },
              { value: "5+", label: "Years Experience" },
            ].map((stat) => (
              <div key={stat.label} className="rounded-[1.75rem] bg-white border border-slate-200 p-5 shadow-sm">
                <p className="text-3xl font-extrabold text-blue-600">{stat.value}</p>
                <p className="text-sm text-slate-500 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap gap-4 animate-fade-in animate-fade-in-delay-400">
            <button
              onClick={() => scrollTo("contact")}
              className="inline-flex items-center justify-center rounded-3xl bg-gradient-to-r from-blue-600 to-indigo-600 px-8 py-3 text-sm font-semibold text-white shadow-lg shadow-blue-200 transition-transform hover:-translate-y-1"
            >
              Start Your Project
            </button>
            <Link
              to="/pricing"
              className="inline-flex items-center justify-center rounded-3xl border border-slate-300 bg-white px-8 py-3 text-sm font-semibold text-slate-700 transition-all hover:border-blue-300 hover:text-blue-600 hover:shadow-sm"
            >
              View Pricing
            </Link>
          </div>
        </div>

        <div className="hidden md:block">
          <div className="relative">
            <div className="absolute -right-8 top-20 h-44 w-44 rounded-full bg-blue-100/70 blur-3xl animate-soft-pulse" />
            <div className="bg-white/95 backdrop-blur-xl rounded-[2rem] border border-slate-200 shadow-2xl p-8 w-full max-w-sm animate-fade-in animate-fade-in-delay-400">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 bg-blue-600 rounded-2xl flex items-center justify-center shadow-lg shadow-blue-200/40">
                  <span className="text-white text-xl">💻</span>
                </div>
                <div>
                  <p className="font-bold text-slate-900">Nexora Ventures Dashboard</p>
                  <p className="text-xs text-slate-400">Project Performance</p>
                </div>
              </div>

              {[
                { label: "Web Development", percent: 92 },
                { label: "Mobile Apps", percent: 78 },
                { label: "Cloud Services", percent: 85 },
              ].map((item) => (
                <div key={item.label} className="mb-4">
                  <div className="flex justify-between mb-2">
                    <span className="text-sm text-slate-600">{item.label}</span>
                    <span className="text-sm font-semibold text-blue-600">{item.percent}%</span>
                  </div>
                  <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
                    <div
                      className="h-2 rounded-full bg-gradient-to-r from-blue-500 to-indigo-500 transition-all"
                      style={{ width: `${item.percent}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>

            <div className="absolute -top-4 -right-4 rounded-full bg-emerald-500 px-4 py-2 text-xs font-semibold text-white shadow-xl animate-float">
              ✓ 24/7 Support
            </div>

            <div className="absolute -bottom-5 -left-8 bg-white rounded-3xl border border-slate-200 shadow-xl p-4 flex items-center gap-3 animate-float">
              <div className="w-10 h-10 rounded-2xl bg-amber-100 flex items-center justify-center text-xl">⭐</div>
              <div>
                <p className="text-xs font-semibold text-slate-900">5.0 Rating</p>
                <p className="text-xs text-slate-400">50+ Reviews</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
